import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalService } from '../services/database/local.service';

export const authGuard = (redirectUrl: string = "public/login"): CanActivateFn => {
  return (route, state) => {
    const localService = inject(LocalService);
    const router = inject(Router);
    if (!localService.isLoggedIn)
      router.navigate([redirectUrl]);
    return true;
  };
};
